import React from 'react';

export default function ContactPage() {
  return (
    <div className="max-w-3xl mx-auto text-center py-12">
      <h2 className="text-3xl font-bold text-gray-900 mb-6">Contacto</h2>
      <p className="text-lg text-gray-600 mb-4">
        ¿Tienes alguna pregunta? Escríbenos a:
      </p>
      <a 
        href="mailto:foirola29640@gmail.com" 
        className="text-gray-900 font-medium hover:text-gray-700"
      >
        foirola29640@gmail.com
      </a>
      <div className="mt-6">
        <a
          href="https://www.instagram.com/foirola.brand"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center text-gray-900 hover:text-gray-700"
        >
          <span role="img" aria-label="Instagram" className="mr-2">📷</span>
          <span>Síguenos en Instagram</span>
        </a>
      </div>
    </div>
  );
} 